import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { resolveShortLink } from 'api/shortLinks'
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { routes } from 'routes/routes'

/**
 * Landing page for short links sent via SMS (`/i/:code`).
 * Resolves the code on the backend and forwards the browser to the full URL
 * (e.g. the caregiver invite registration page with its JWT).
 */
export const ShortLinkRedirectPage = () => {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()

  const { isError } = useQuery(['resolveShortLink', code], () => resolveShortLink(code ?? ''), {
    enabled: !!code,
    retry: false,
    onSuccess: ({ data }) => {
      window.location.replace(data.url)
    },
  })

  const isInvalid = !code || isError

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      {isInvalid ? (
        <>
          <Typography variant="h5" textAlign="center" color="error.main" mb={3}>
            This link is invalid or has expired. Please ask for a new invitation.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(routes.signIn)}
            sx={{ minWidth: 160 }}
          >
            Go to Home
          </Button>
        </>
      ) : (
        <>
          <CircularProgress size={48} />
          <Typography variant="body1" color="text.secondary" mt={2}>
            Opening your link...
          </Typography>
        </>
      )}
    </Box>
  )
}
